import '../../personalisation/src/utilities/instrument';

import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { reactErrorHandler } from '@sentry/react';

import App from './App';
import { GiftWrapProvider } from './context/GiftWrapContext';
import { LocaleProvider } from './context/LocaleContext';
import { pages } from './context/pages';
import { isPackagingFlowEnabled } from './packaging/flag';
import { applyPackagingPageOverrides } from './packaging/pageOverrides';
import { UvInsertsContextProvider } from './uv-inserts/context/UvInsertsContext';

import './components/giftWrap-global.css';
import { logError } from './utilities/logging';

const container = document.getElementById('react-gift-wrap-ui');
// Ensure the container exists before proceeding
if (!container) {
  throw new Error('Container element with id "react-gift-wrap-ui" not found');
}
if (isPackagingFlowEnabled()) {
  applyPackagingPageOverrides(pages);
}

createRoot(container, {
  onUncaughtError: reactErrorHandler((error, errorInfo) => {
    logError({
      label: 'root-gift.jsx',
      error,
      message: 'Uncaught error in Gift Wrap',
      extraData: {
        errorInfo
      }
    });
    // Error handled by Sentry
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: reactErrorHandler()
}).render(
  <StrictMode>
    <UvInsertsContextProvider>
      <GiftWrapProvider>
        <LocaleProvider>
          <App />
        </LocaleProvider>
      </GiftWrapProvider>
    </UvInsertsContextProvider>
  </StrictMode>
);
